export const comments_5519473 = {"data":{"data":[],"links":{}}}